import React, {FC} from 'react'

import cn from 'classnames/bind'

import SectionTestimonials, {
	ISectionTestimonialsItem,
} from 'components/blocks/SectionTestimonials/SectionTestimonials'
import {Col, Container, Row} from 'components/elements/grid'
import {IInvoiceContent} from 'pages/invoice-generator'

import s from './InvoiceTestimonials.module.scss'
import LandingsTitle from '../../LandingsTitle/LandingsTitle'
const cx = cn.bind(s)

interface IInvoiceTestimonialsProps {
	className?: string
	content: IInvoiceContent['testimonials']
}

/** InvoiceTestimonials block component */
const InvoiceTestimonials: FC<IInvoiceTestimonialsProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} />
				<Row>
					<Col>
						<SectionTestimonials items={(content?.items as ISectionTestimonialsItem[]) || []} />
					</Col>
				</Row>
			</Container>
		</div>
	)
}

InvoiceTestimonials.displayName = 'InvoiceTestimonials'

export default InvoiceTestimonials
